import * as React from 'react';

function SvgReconciliationAccountBook(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#reconciliation-accountBook_svg__clip0_1619_26022)">
        <path
          d="M14.571 2.145h-3V1.002a.143.143 0 00-.143-.143h-1a.143.143 0 00-.143.143v1.143h-4.57V1.002A.143.143 0 005.57.86h-1a.143.143 0 00-.143.143v1.143h-3a.57.57 0 00-.571.572v11.857a.57.57 0 00.571.571h13.143a.57.57 0 00.572-.571V2.717a.57.57 0 00-.572-.572zm-.714 11.714H2.143V3.431h2.285v.857c0 .079.065.143.143.143h1a.143.143 0 00.143-.143v-.857h4.572v.857c0 .079.064.143.142.143h1a.143.143 0 00.143-.143v-.857h2.286v10.428zm-3.58-7.607h-.804a.14.14 0 00-.127.079l-1.31 2.596h-.05L6.675 6.331a.143.143 0 00-.127-.079h-.821a.144.144 0 00-.125.213l1.594 2.928h-.868a.143.143 0 00-.142.143v.38c0 .08.064.143.142.143h1.163v.602H6.328a.143.143 0 00-.142.143v.38c0 .079.064.143.142.143h1.163v.96c0 .08.064.144.143.144h.737a.143.143 0 00.143-.143v-.96h1.168a.143.143 0 00.143-.144v-.38a.143.143 0 00-.143-.143H8.514v-.602h1.168a.143.143 0 00.143-.142v-.38a.143.143 0 00-.143-.144h-.877l1.595-2.93a.154.154 0 00.018-.068.14.14 0 00-.141-.143z"
          fill="#000"
          fillOpacity={0.45}
        />
      </g>
      <defs>
        <clipPath id="reconciliation-accountBook_svg__clip0_1619_26022">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgReconciliationAccountBook;
